(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurova-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── IntersectionObserver: scroll reveals ── */
  var revealSels = '.aur-about .ao-reveal, .aur-about .ao-reveal-l, .aur-about .ao-reveal-r, .aur-about .ao-reveal-s';
  var revealEls  = document.querySelectorAll(revealSels);
  var revObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ao-in');
        revObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.14 });
  revealEls.forEach(function (el) { revObs.observe(el); });
  setTimeout(function() {
    revealEls.forEach(function(el) { el.classList.add('ao-in'); });
  }, 1200);

  /* ── Hero background slow zoom ── */
  var heroRoot = document.getElementById('ao-hero-root');
  if (heroRoot) requestAnimationFrame(function () { heroRoot.classList.add('ao-hero--ready'); });

  /* ── Nature section parallax trigger ── */
  var natureRoot = document.getElementById('ao-nature-root');
  if (natureRoot) {
    var natObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('ao-in', e.isIntersecting);
      });
    }, { threshold: 0.1 });
    natObs.observe(natureRoot);
  }

  /* ── Stat counter animation ── */
  var countEls = document.querySelectorAll('.aur-about .ao-stat__count');
  var cntObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el       = e.target;
      var target   = parseInt(el.getAttribute('data-count'), 10) || 0;
      var duration = 1800;
      var startTs  = null;
      function tick(ts) {
        if (!startTs) startTs = ts;
        var progress = Math.min((ts - startTs) / duration, 1);
        var eased    = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(eased * target).toLocaleString();
        if (progress < 1) requestAnimationFrame(tick);
        else el.textContent = target.toLocaleString();
      }
      requestAnimationFrame(tick);
      cntObs.unobserve(el);
    });
  }, { threshold: 0.6 });
  countEls.forEach(function (el) { cntObs.observe(el); });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-cart"] && !Shopify.designMode) return;
  try {
    
/* ── Aurova Cart Page — AJAX interactions ── */
(function () {
  /* Read the merchant-configured threshold from the section setting
     (data attribute) so JS stays in sync with the server render. */
  var shipBar = document.querySelector('.aur-cart__shipping-bar');
  var FREE_SHIPPING = shipBar && shipBar.dataset.freeShippingCents
    ? parseInt(shipBar.dataset.freeShippingCents, 10)
    : 5000;

  function fmt(cents) {
    var d = (cents / 100).toFixed(2).split('.');
    d[0] = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + d[0] + '.' + d[1];
  }

  function updateShippingBar(subtotal) {
    var pct = Math.min((subtotal / FREE_SHIPPING) * 100, 100);
    var fill = document.querySelector('[data-shipping-fill]');
    var msg  = document.querySelector('[data-shipping-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (subtotal >= FREE_SHIPPING) {
        msg.innerHTML = 'You\'ve unlocked <strong>free shipping</strong>';
      } else {
        var rem = FREE_SHIPPING - subtotal;
        msg.innerHTML = 'You\'re <strong>' + fmt(rem) + '</strong> away from free shipping!';
      }
    }
  }

  function updateSummary(cart) {
    /* Mirror the server render: Subtotal = pre-discount items,
       Total = discount-net cart.total_price (tax/shipping are checkout-only). */
    var sub   = (typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : cart.total_price;
    var total = cart.total_price;

    var elSub      = document.querySelector('[data-summary-subtotal]');
    var elTotal    = document.querySelector('[data-summary-total]');
    var elCount    = document.querySelector('[data-cart-count]');
    var elShipping = document.querySelector('[data-summary-shipping]');

    if (elSub)   elSub.textContent   = fmt(sub);
    if (elTotal) elTotal.textContent = fmt(total);
    if (elCount) {
      elCount.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'ITEM' : 'ITEMS');
    }
    if (elShipping) {
      if (total >= FREE_SHIPPING) {
        elShipping.textContent = 'Free';
        elShipping.classList.add('aur-cart__summary-free');
      } else {
        elShipping.textContent = 'Calculated at checkout';
        elShipping.classList.remove('aur-cart__summary-free');
      }
    }

    updateShippingBar(total);

    /* Sync header badge */
    var badge = document.getElementById('aur-cart-badge');
    if (badge) {
      var n = cart.item_count;
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.classList.toggle('aur-hdr__cart-badge--hidden', n === 0);
    }
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() }));
    } catch (_) {}
  }

  function removeItemEl(itemEl) {
    itemEl.style.transition = 'opacity 0.25s ease, max-height 0.35s ease, padding 0.35s ease, margin 0.35s ease';
    itemEl.style.overflow   = 'hidden';
    itemEl.style.maxHeight  = itemEl.offsetHeight + 'px';
    itemEl.style.opacity    = '0';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        itemEl.style.maxHeight  = '0';
        itemEl.style.paddingTop = '0';
        itemEl.style.paddingBottom = '0';
        itemEl.style.marginBottom  = '0';
        itemEl.style.borderWidth   = '0';
        setTimeout(function () { itemEl.remove(); }, 380);
      });
    });
  }

  function changeItem(key, quantity) {
    var itemEl = document.querySelector('[data-item-key="' + CSS.escape(key) + '"]');
    if (itemEl) itemEl.classList.add('aur-cart__item--loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
    .then(function (res) {
      var cart = res.body;
      /* 422 (stock limit etc.) returns {status, description} — NOT a cart.
         Bail out cleanly instead of writing undefined values ($NaN) to the DOM. */
      if (!res.ok || (cart && cart.status)) {
        if (itemEl) {
          itemEl.classList.remove('aur-cart__item--loading');
          var msg = (cart && (cart.description || cart.message)) || 'Unable to update quantity';
          var msgEl = document.querySelector('[data-shipping-msg]');
          if (msgEl) {
            var prev = msgEl.innerHTML;
            msgEl.textContent = msg;
            setTimeout(function () { msgEl.innerHTML = prev; }, 3000);
          }
        }
        return;
      }

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      if (quantity === 0) {
        if (itemEl) removeItemEl(itemEl);
      } else {
        if (itemEl) {
          itemEl.classList.remove('aur-cart__item--loading');

          var updatedItem = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key) { updatedItem = cart.items[i]; break; }
          }
          /* Trust Shopify's returned quantity, not the requested one */
          var qtyEl = itemEl.querySelector('[data-qty]');
          if (qtyEl) qtyEl.textContent = updatedItem ? updatedItem.quantity : quantity;
          if (updatedItem) {
            var priceEl = itemEl.querySelector('[data-item-price]');
            if (priceEl) priceEl.textContent = fmt(updatedItem.final_line_price);
          }
        }
      }

      updateSummary(cart);
    })
    .catch(function () {
      if (itemEl) itemEl.classList.remove('aur-cart__item--loading');
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action  = btn.dataset.action;
    var itemEl  = btn.closest('[data-item-key]');
    if (!itemEl) return;
    var key     = itemEl.dataset.itemKey;
    var qtyEl   = itemEl.querySelector('[data-qty]');
    var current = parseInt(qtyEl ? qtyEl.textContent.trim() : '1', 10);

    if (action === 'increase') {
      changeItem(key, current + 1);
    } else if (action === 'decrease') {
      changeItem(key, Math.max(0, current - 1));
    } else if (action === 'remove') {
      changeItem(key, 0);
    }
  });

  /* ── Apply promo code via Shopify's /discount/ route (returns to cart) ── */
  var discountForm = document.getElementById('aur-cart-discount-form');
  if (discountForm) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = discountForm.querySelector('[name="discount"]');
      var code  = input && input.value ? input.value.trim() : '';
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Scroll reveal ── */
  var els = document.querySelectorAll('.aur-contact .co-reveal, .aur-contact .co-reveal-l, .aur-contact .co-reveal-r');
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('co-in'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { obs.observe(el); });
  setTimeout(function() {
    els.forEach(function(el) { el.classList.add('co-in'); });
  }, 1200);

  /* ── Hero bg slow zoom ── */
  var hero = document.getElementById('co-hero-root');
  if (hero) requestAnimationFrame(function () { hero.classList.add('co-rdy'); });

  /* ── FAQ accordion ── */
  document.querySelectorAll('.aur-contact .co-faq__item').forEach(function (item) {
    var btn  = item.querySelector('.co-faq__q');
    var body = item.querySelector('.co-faq__body');
    if (!btn || !body) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('co-open');

      document.querySelectorAll('.aur-contact .co-faq__item.co-open').forEach(function (other) {
        if (other === item) return;
        other.classList.remove('co-open');
        other.querySelector('.co-faq__body').style.maxHeight = '0';
        other.querySelector('.co-faq__q').setAttribute('aria-expanded', 'false');
      });

      if (isOpen) {
        item.classList.remove('co-open');
        body.style.maxHeight = '0';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('co-open');
        body.style.maxHeight = body.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-featured-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aurova-fc').forEach(function(section) {

  /* ── Staggered entrance animation ── */
  var cards = section.querySelectorAll('[data-animate]');
  if (cards.length) {
    var grid = section.querySelector('.aurova-fc__grid');
    var cols = parseInt(grid ? getComputedStyle(grid).getPropertyValue('--cols').trim() : '4', 10) || 4;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el  = entry.target;
        var idx = parseInt(el.dataset.index || 0, 10);
        el.style.animationDelay = (idx % cols * 90) + 'ms';
        el.classList.add('is-visible');
        obs.unobserve(el);
      });
    }, { threshold: 0.08 });
    cards.forEach(function(c) { obs.observe(c); });
  }

  /* ── Wishlist initial state (clicks handled by aurova-wishlist.js) ── */
  section.querySelectorAll('.aurova-fc__wishlist[data-aurova-wishlist-btn]').forEach(function(btn) {
    var wl = window.AurovaWishlist;
    if (wl && wl.has(btn.dataset.productId)) {
      btn.classList.add('aur-wl-btn--active');
      btn.setAttribute('aria-pressed', 'true');
    }
  });

  /* ── Shared cart-add helper ── */
  /* Uses FormData + X-Requested-With to match the theme's own fetchConfig('javascript') */
  function aurovaCartAdd(variantId, btn, labelSuccess, labelOrig) {
    btn.textContent = '· · ·';
    btn.disabled    = true;

    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');

    var cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url)
      ? window.Theme.routes.cart_add_url
      : '/cart/add.js';

    fetch(cartUrl, {
      method:  'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept':           'application/json'
      },
      body: fd
    })
    .then(function(res) { return res.json(); })
    .then(function(response) {
      /* Shopify returns { status: 422, message, description } on error */
      if (response.status) {
        console.warn('[Aurova] Cart add error:', response.description || response.message);
        btn.textContent = labelOrig;
        btn.disabled    = false;
        return null;
      }
      btn.textContent = labelSuccess;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    })
    .then(function(r) { if (!r) return null; return r.json(); })
    .then(function(cart) {
      if (!cart) return;
      /* Directly update the Aurova header cart badge */
      var aurBadge = document.getElementById('aur-cart-badge');
      if (aurBadge) {
        var n = parseInt(cart.item_count, 10) || 0;
        aurBadge.textContent = n > 99 ? '99+' : String(n);
        if (n > 0) {
          aurBadge.classList.remove('aur-hdr__cart-badge--hidden');
        } else {
          aurBadge.classList.add('aur-hdr__cart-badge--hidden');
        }
        try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() })); } catch (_) {}
      }
      /* Dispatch cart:update for the theme's native cart-drawer / cart-icon */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { itemCount: cart.item_count, didError: false } }
      }));
      setTimeout(function() { btn.textContent = labelOrig; btn.disabled = false; }, 2000);
    })
    .catch(function(err) {
      console.warn('[Aurova] Cart fetch error:', err.message);
      btn.textContent = labelOrig;
      btn.disabled    = false;
    });
  }

  /* ── AJAX quick-add (pill forms) ── */
  section.querySelectorAll('.aurova-fc__add-form--pill').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn      = form.querySelector('.aurova-fc__pill-btn');
      var input    = form.querySelector('[name="id"]');
      if (!btn || !input || !input.value) return;
      var variantId = parseInt(input.value, 10);
      if (!variantId) return;
      aurovaCartAdd(variantId, btn, '✓ ADDED', 'ADD TO CART');
    });
  });

  /* ── AJAX overlay-style add forms ── */
  section.querySelectorAll('.aurova-fc__add-form:not(.aurova-fc__add-form--pill)').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn      = form.querySelector('.aurova-fc__add-btn');
      var input    = form.querySelector('[name="id"]');
      if (!btn || !input || !input.value) return;
      var variantId = parseInt(input.value, 10);
      if (!variantId) return;
      aurovaCartAdd(variantId, btn, 'Added ✓', 'Add to Cart');
    });
  });
});

/* ════════════════════════════════════
   3-D Floating Orb Background (Canvas)
════════════════════════════════════ */
(function() {
  document.querySelectorAll('.aurova-fc').forEach(function(sec) {
    var canvas = sec.querySelector('.aurova-fc__canvas');
    if (!canvas || canvas.dataset.init) return;
    canvas.dataset.init = '1';

    /* Respect reduced-motion: skip the animated orb background entirely */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      canvas.style.display = 'none';
      return;
    }

    var ctx    = canvas.getContext('2d');
    var raf    = null;
    var active = false;
    var mx = 0, my = 0, tmx = 0, tmy = 0;

    var ORBS = [
      { bx: -260, by: -180, bz:  80, r: 300, rgb: [141,171,120], ph: 0.00, sp: 0.80 },
      { bx:  230, by:  140, bz: 230, r: 390, rgb: [141,171,120], ph: 1.57, sp: 0.52 },
      { bx:  -75, by:  230, bz: -60, r: 220, rgb: [242,184,198], ph: 2.40, sp: 1.10 },
      { bx:  310, by: -210, bz: 130, r: 260, rgb: [242,184,198], ph: 3.80, sp: 0.75 },
      { bx:   45, by:   55, bz: 330, r: 430, rgb: [251,247,240], ph: 0.90, sp: 0.48 },
      { bx: -330, by:  115, bz: -90, r: 290, rgb: [141,171,120], ph: 4.50, sp: 0.92 },
      { bx:  125, by: -285, bz:  45, r: 240, rgb: [45,  74,  62], ph: 1.80, sp: 0.70 },
      { bx: -165, by:  320, bz: 165, r: 330, rgb: [251,247,240], ph: 5.20, sp: 0.58 },
      { bx:  290, by:  -55, bz: -45, r: 190, rgb: [141,171,120], ph: 2.80, sp: 1.00 },
      { bx: -205, by: -310, bz: 105, r: 215, rgb: [242,184,198], ph: 6.10, sp: 0.83 },
    ];

    function resize() { canvas.width = sec.offsetWidth; canvas.height = sec.offsetHeight; }

    function rgba(rgb, a) {
      return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + Math.max(0, a).toFixed(3) + ')';
    }

    function drawOrb(orb, t, W, H) {
      var x = orb.bx
            + Math.sin(t * 0.00034 * orb.sp + orb.ph)       * 90
            + Math.cos(t * 0.00019 * orb.sp + orb.ph * 1.7) * 40;
      var y = orb.by
            + Math.cos(t * 0.00028 * orb.sp + orb.ph * 1.3) * 70
            + Math.sin(t * 0.00021 * orb.sp + orb.ph * 0.8) * 34;
      var z = orb.bz
            + Math.sin(t * 0.00016 * orb.sp + orb.ph * 0.55) * 90;
      var df = (z + 450) / 750;
      x += mx * df * 0.5; y += my * df * 0.35;
      var P = 780, scale = P / (P + z);
      var sx = W * 0.5 + x * scale, sy = H * 0.5 + y * scale, sr = orb.r * scale;
      if (sr < 2) return;
      var alpha = 0.028 + scale * 0.058;
      var lx = sx - sr * 0.32, ly = sy - sr * 0.38;
      var g = ctx.createRadialGradient(lx, ly, 0, sx, sy, sr);
      g.addColorStop(0,    rgba(orb.rgb, alpha * 2.0));
      g.addColorStop(0.38, rgba(orb.rgb, alpha * 1.1));
      g.addColorStop(0.80, rgba(orb.rgb, alpha * 0.35));
      g.addColorStop(1,    rgba(orb.rgb, 0));
      ctx.beginPath(); ctx.arc(sx, sy, sr, 0, Math.PI * 2);
      ctx.fillStyle = g; ctx.fill();
      var hl = ctx.createRadialGradient(lx, ly, 0, lx, ly, sr * 0.46);
      hl.addColorStop(0, 'rgba(255,255,255,' + (alpha * 0.55).toFixed(3) + ')');
      hl.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.beginPath(); ctx.arc(sx, sy, sr, 0, Math.PI * 2);
      ctx.fillStyle = hl; ctx.fill();
    }

    function tick(t) {
      if (!active) return;
      var W = canvas.width, H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      mx += (tmx - mx) * 0.055; my += (tmy - my) * 0.055;
      ORBS.slice().sort(function(a, b) { return b.bz - a.bz; }).forEach(function(orb) { drawOrb(orb, t, W, H); });
      raf = requestAnimationFrame(tick);
    }

    sec.addEventListener('mousemove', function(e) {
      var r = sec.getBoundingClientRect();
      tmx = (e.clientX - r.left  - r.width  * 0.5) * 0.07;
      tmy = (e.clientY - r.top   - r.height * 0.5) * 0.07;
    });
    sec.addEventListener('mouseleave', function() { tmx = 0; tmy = 0; });

    new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { active = true; raf = requestAnimationFrame(tick); }
        else { active = false; if (raf) { cancelAnimationFrame(raf); raf = null; } }
      });
    }, { threshold: 0.05 }).observe(sec);

    resize();
    var resizeTimer;
    window.addEventListener('resize', function() { clearTimeout(resizeTimer); resizeTimer = setTimeout(resize, 150); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT     = document.getElementById('aur-hdr-root');
  var HDR      = document.getElementById('aur-hdr');
  var HAM      = document.getElementById('aur-ham');
  var DRAWER   = document.getElementById('aur-drawer');
  var OVERLAY  = document.getElementById('aur-drawer-overlay');
  var CLOSE    = document.getElementById('aur-drawer-close');
  var CART     = document.getElementById('aur-cart-btn');
  var SEARCH   = document.getElementById('aur-search-btn');
  var BADGE    = document.getElementById('aur-cart-badge');
  var ACCT_BTN = document.getElementById('aur-account-btn');
  var ACCT_DD  = document.getElementById('aur-acct-dd');
  var ACCT_WRAP= document.getElementById('aur-acct-wrap');

  if (!ROOT || !HDR) return;

  var sticky     = (ROOT.dataset.sticky || 'always');
  var transHome  = ROOT.dataset.transparentHome === 'true';
  var lastScroll = 0;

  /* ── Sticky / scroll shadow ── */
  function onScroll() {
    var sy = window.scrollY;
    var scrolled = sy > 10;

    if (scrolled) {
      HDR.classList.add('is-scrolled');
    } else {
      HDR.classList.remove('is-scrolled');
    }

    if (sticky === 'scroll-up') {
      if (sy > lastScroll && sy > 100) {
        HDR.style.transform = 'translateY(-100%)';
      } else {
        HDR.style.transform = '';
      }
    }

    lastScroll = sy;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Set --header-height CSS var (used by theme for content offset) ── */
  function updateHeightVar() {
    var h = HDR.offsetHeight;
    document.body.style.setProperty('--header-height', h + 'px');
    document.body.style.setProperty('--header-group-height', h + 'px');
  }

  updateHeightVar();
  window.addEventListener('resize', updateHeightVar);

  /* ── Mobile drawer ── */
  function openDrawer() {
    DRAWER.classList.add('is-open');
    DRAWER.setAttribute('aria-hidden', 'false');
    HAM.classList.add('is-open');
    HAM.setAttribute('aria-expanded', 'true');
    document.body.classList.add('aur-drawer-lock');
    /* Make focusable items reachable */
    DRAWER.querySelectorAll('a,button,summary').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
    CLOSE.focus();
  }

  function closeDrawer() {
    DRAWER.classList.remove('is-open');
    DRAWER.setAttribute('aria-hidden', 'true');
    HAM.classList.remove('is-open');
    HAM.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('aur-drawer-lock');
    DRAWER.querySelectorAll('a,button,summary').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    HAM.focus();
  }

  if (HAM)     HAM.addEventListener('click', openDrawer);
  if (CLOSE)   CLOSE.addEventListener('click', closeDrawer);
  if (OVERLAY) OVERLAY.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && DRAWER.classList.contains('is-open')) closeDrawer();
  });

  /* ── Account dropdown (logged-in only; logged-out uses direct <a> link) ── */
  if (ACCT_BTN && ACCT_DD) {
    ACCT_BTN.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = !ACCT_DD.hidden;
      ACCT_DD.hidden = isOpen;
      ACCT_BTN.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
    document.addEventListener('click', function (e) {
      if (!ACCT_DD.hidden && ACCT_WRAP && !ACCT_WRAP.contains(e.target)) {
        ACCT_DD.hidden = true;
        ACCT_BTN.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !ACCT_DD.hidden) {
        ACCT_DD.hidden = true;
        ACCT_BTN.setAttribute('aria-expanded', 'false');
        ACCT_BTN.focus();
      }
    });
  }

  /* ── Search button: open theme's search modal ── */
  if (SEARCH) {
    SEARCH.addEventListener('click', function () {
      var modal = document.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') {
        modal.showDialog();
      } else {
        window.location.href = '/search';
      }
    });
  }

  /* ── Live cart badge update ── */
  function setCartBadge(count) {
    if (!BADGE) return;
    var n = Number(count) || 0;
    BADGE.textContent = n > 99 ? '99+' : String(n);
    if (n > 0) {
      BADGE.classList.remove('aur-hdr__cart-badge--hidden');
    } else {
      BADGE.classList.add('aur-hdr__cart-badge--hidden');
    }
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartBadge(cart.item_count); })
      .catch(function () {});
  }

  /* Primary: listen to cart:update — fired by product-card.liquid and the theme's native forms */
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.data && e.detail.data.didError) return;
    var resource = e.detail && e.detail.resource;
    if (resource && typeof resource.item_count === 'number') {
      setCartBadge(resource.item_count);
    } else {
      fetchCartCount();
    }
  });

  /* Re-sync badge when navigating back from another page (e.g. /cart) */
  window.addEventListener('pageshow', function (e) {
    fetchCartCount();
  });

  /* Fallback: catch form submits on any product-form-component and poll after a short delay */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.closest('product-form-component')) {
      setTimeout(fetchCartCount, 600);
    }
  });

  /* ── Desktop dropdown: keyboard a11y ── */
  document.querySelectorAll('.aur-hdr__nav-item--has-dd').forEach(function (item) {
    var link = item.querySelector('.aur-hdr__nav-link');

    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        item.classList.toggle('dd-open');
        link.setAttribute('aria-expanded', item.classList.contains('dd-open') ? 'true' : 'false');
      }
      if (e.key === 'Escape') {
        item.classList.remove('dd-open');
        link.setAttribute('aria-expanded', 'false');
      }
    });

    /* Close on click outside */
    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) {
        item.classList.remove('dd-open');
        if (link) link.setAttribute('aria-expanded', 'false');
      }
    });
  });

})();

/* ── Auto session logout ── */
(function () {
  var modal = document.getElementById('aur-session-modal');
  if (!modal) return; // element only exists in DOM when customer is logged in

  var TIMEOUT_MS = parseInt(modal.dataset.timeout, 10) || 1800000; // default 30 min
  var WARNING_MS = parseInt(modal.dataset.warning,  10) || 120000;  // default 2 min
  var LOGOUT_URL = modal.dataset.logout || '/account/logout';

  var countdown    = document.getElementById('aur-sm-countdown');
  var stayBtn      = document.getElementById('aur-sm-stay');
  var warningTimer = null;
  var logoutTimer  = null;
  var tickInterval = null;
  var warningStart = 0;

  function fmtTime(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(s / 60);
    s = s % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function showWarning() {
    modal.hidden = false;
    warningStart = Date.now();
    tickInterval = setInterval(function () {
      var left = WARNING_MS - (Date.now() - warningStart);
      if (countdown) countdown.textContent = fmtTime(left);
    }, 500);
  }

  function hideWarning() {
    modal.hidden = true;
    if (tickInterval) { clearInterval(tickInterval); tickInterval = null; }
    if (countdown) countdown.textContent = fmtTime(WARNING_MS);
  }

  function doLogout() {
    window.location.href = LOGOUT_URL;
  }

  function resetTimers() {
    clearTimeout(warningTimer);
    clearTimeout(logoutTimer);
    hideWarning();
    warningTimer = setTimeout(showWarning, TIMEOUT_MS - WARNING_MS);
    logoutTimer  = setTimeout(doLogout,   TIMEOUT_MS);
  }

  var actThrottle = null;
  function onActivity() {
    if (actThrottle || !modal.hidden) return; // don't reset while warning is showing
    actThrottle = setTimeout(function () { actThrottle = null; }, 1000);
    resetTimers();
  }

  ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, onActivity, { passive: true });
  });

  if (stayBtn) stayBtn.addEventListener('click', resetTimers);

  resetTimers(); // start on page load
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-nature"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aurova-nat').forEach(function(sec) {
  if (sec.dataset.natInit) return;
  sec.dataset.natInit = '1';

  var orbWrap = sec.querySelector('[data-nat-orb]');
  var texts   = sec.querySelectorAll('[data-nat-text]');
  if (!orbWrap && !texts.length) return;

  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      if (el.hasAttribute('data-nat-orb')) {
        el.classList.add('is-visible');
      } else {
        var d = parseInt(el.dataset.delay || 0, 10);
        setTimeout(function() { el.classList.add('is-visible'); }, d);
      }
      obs.unobserve(el);
    });
  }, { threshold: 0.2 });

  if (orbWrap) obs.observe(orbWrap);
  texts.forEach(function(el) { obs.observe(el); });
  setTimeout(function() {
    if (orbWrap) orbWrap.classList.add('is-visible');
    texts.forEach(function(el) { el.classList.add('is-visible'); });
  }, 1200);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-product"] && !Shopify.designMode) return;
  try {
    
/* ── Aurova Product Detail Page ── */
(function () {

  /* ── Entrance animations (transition-based, always visible) ── */
  (function triggerEntrance() {
    var delays = [0, 55, 100, 150, 200, 255, 310, 365, 420];
    document.querySelectorAll('.aur-pdp .aur-fade-up').forEach(function(el) {
      var m = el.className.match(/aur-fade-up--(\d)/);
      var idx = m ? parseInt(m[1], 10) - 1 : 0;
      setTimeout(function() { el.classList.add('aur-in'); }, delays[idx] || 0);
    });
    /* Safety net: ensure all visible within 1.5s if timeouts stall */
    setTimeout(function() {
      document.querySelectorAll('.aur-pdp .aur-fade-up').forEach(function(el) { el.classList.add('aur-in'); });
    }, 1500);
  })();

  /* ── Read product data ── */
  var dataEl = document.getElementById('aur-pdp-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var product        = data.product;
  var IS_LOGGED_IN   = data.isLoggedIn === true;
  var SIGN_IN_URL    = data.signInUrl || '/account/login';
  var INVENTORY      = data.inventory || {};   /* {variant_id: qty|null} — product|json no longer exposes this */
  var allVariants    = product.variants;

  /* Tracked inventory qty for a variant, or null when untracked/unknown */
  function inventoryFor(variant) {
    if (!variant) return null;
    var q = INVENTORY[String(variant.id)];
    return (typeof q === 'number') ? q : null;
  }
  var currentOptions = [];
  var currentQty     = 1;
  var currentVariant = allVariants.find(function (v) { return v.id === data.currentVariantId; }) || allVariants[0];

  /* ── DOM refs ── */
  var variantIdInput = document.getElementById('aur-variant-id');
  var formQtyInput   = document.getElementById('aur-form-qty');
  var qtyDisplay     = document.getElementById('aur-qty-display');
  var atcBtn         = document.getElementById('aur-pdp-atc');
  var atcLabel       = document.getElementById('aur-atc-label');
  var buyNow         = document.getElementById('aur-buy-now');
  var priceWrap      = document.getElementById('aur-pdp-price');
  var stockEl        = document.getElementById('aur-stock-indicator');
  var stickyBar      = document.getElementById('aur-sticky-bar');
  var stickyAtc      = document.getElementById('aur-sticky-atc');
  var stickyPrice    = document.getElementById('aur-sticky-price');
  var mainImg        = document.getElementById('aur-main-img');
  var mainFrame      = document.getElementById('aur-img-inner');
  var thumbs         = document.querySelectorAll('.aur-pdp__thumb');
  var dots           = document.querySelectorAll('.aur-pdp__dot');

  /* ── Init selected options from current variant ── */
  if (currentVariant) {
    currentOptions = currentVariant.options.slice();
  }

  /* ── Helpers ── */
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function findVariant(opts) {
    return allVariants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  /* ── Update price block ── */
  function updatePrice(variant) {
    if (!priceWrap || !variant) return;
    var isSale = variant.compare_at_price > variant.price && variant.available;
    if (isSale) {
      var save = variant.compare_at_price - variant.price;
      priceWrap.innerHTML =
        '<span class="aur-pdp__price-sale" data-sale-price>' + fmt(variant.price) + '</span>' +
        '<span class="aur-pdp__price-compare" data-compare-price>' + fmt(variant.compare_at_price) + '</span>' +
        '<span class="aur-pdp__price-save" data-save-badge>Save ' + fmt(save) + '</span>';
    } else {
      priceWrap.innerHTML = '<span class="aur-pdp__price-regular" data-regular-price>' + fmt(variant.price) + '</span>';
    }
    if (stickyPrice) stickyPrice.textContent = fmt(variant.price);
  }

  /* ── Update ATC button state ── */
  function updateAtcState(variant) {
    if (!atcBtn || !atcLabel) return;
    if (!variant || !variant.available) {
      atcBtn.disabled = true;
      atcLabel.textContent = 'Sold Out';
    } else {
      atcBtn.disabled = false;
      atcLabel.textContent = 'Add to Cart';
    }
  }

  /* ── Update stock indicator ── */
  function updateStock(variant) {
    if (!stockEl || !variant) return;
    var qty = inventoryFor(variant);
    if (!variant.available) {
      stockEl.innerHTML = '<span class="aur-pdp__stock-dot aur-pdp__stock-dot--out"></span>Out of stock';
    } else if (qty !== null && qty > 0 && qty <= 10) {
      stockEl.innerHTML = '<span class="aur-pdp__stock-dot aur-pdp__stock-dot--low"></span>Only ' + qty + ' left';
    } else {
      stockEl.innerHTML = '<span class="aur-pdp__stock-dot aur-pdp__stock-dot--ok"></span>In stock';
    }
  }

  /* ── Update Buy Now link ── */
  function updateBuyNow(variant, qty) {
    if (!buyNow || !variant) return;
    /* Logged-out users are routed to the Aurova sign-in page instead of checkout */
    buyNow.href = IS_LOGGED_IN ? ('/cart/' + variant.id + ':' + qty) : SIGN_IN_URL;
    buyNow.textContent = 'Buy it now — ' + fmt(variant.price);
  }

  /* ── Update hidden form inputs ── */
  function updateFormInputs(variant, qty) {
    if (variantIdInput) variantIdInput.value = variant ? variant.id : '';
    if (formQtyInput)   formQtyInput.value   = qty;
  }

  /* ── Update URL without reload ── */
  function updateUrl(variant) {
    if (!variant || !window.history) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  /* ── Full variant update ── */
  function applyVariant(variant) {
    currentVariant = variant;
    updatePrice(variant);
    updateAtcState(variant);
    updateStock(variant);
    updateBuyNow(variant, currentQty);
    updateFormInputs(variant, currentQty);
    updateUrl(variant);

    /* Swap to variant image if it has one */
    if (variant && variant.featured_image) {
      var imgSrc = variant.featured_image.src;
      switchImage(imgSrc, '', null);

      /* Activate matching thumbnail */
      var imgId = variant.featured_image.id;
      thumbs.forEach(function (t, i) {
        if (product.images[i] && product.images[i].id === imgId) {
          activateThumb(i);
        }
      });
    }
  }

  /* ── Variant option pills ── */
  document.querySelectorAll('.aur-pdp__opt-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var optIdx = parseInt(this.dataset.optIndex, 10);
      var val    = this.dataset.optValue;

      /* Update selected options */
      currentOptions[optIdx] = val;

      /* Update UI pills for this group */
      var group = this.closest('.aur-pdp__opt-pills');
      if (group) {
        group.querySelectorAll('.aur-pdp__opt-pill').forEach(function (p) {
          var isActive = p.dataset.optValue === val;
          p.classList.toggle('is-active', isActive);
          p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      /* Update label */
      var valEl = document.querySelector('[data-opt-val="' + optIdx + '"]');
      if (valEl) valEl.textContent = val;

      /* Find + apply variant */
      var matched = findVariant(currentOptions);
      if (matched) applyVariant(matched);
    });
  });

  /* ── Quantity controls ── */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var action = this.dataset.qty;
      var invQty = inventoryFor(currentVariant);
      var maxQty = (invQty !== null && invQty > 0) ? invQty : 99;
      if (action === 'inc') currentQty = Math.min(currentQty + 1, maxQty);
      if (action === 'dec') currentQty = Math.max(currentQty - 1, 1);
      if (qtyDisplay)  qtyDisplay.textContent  = currentQty;
      if (formQtyInput) formQtyInput.value       = currentQty;
      updateBuyNow(currentVariant, currentQty);
    });
  });

  /* ── AJAX Add to Cart ── */
  var productForm = document.getElementById('aur-product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!currentVariant || !currentVariant.available) return;
      if (atcBtn && atcBtn.disabled) return;

      /* Loading state */
      if (atcBtn) atcBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: currentVariant.id, quantity: currentQty })
      })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        /* /cart/add.js returns 422 + {status, description} on stock/sold-out errors */
        if (!res.ok || (res.body && res.body.status)) {
          var msg = (res.body && (res.body.description || res.body.message)) || 'Unable to add';
          throw new Error(msg);
        }
        /* Success */
        if (atcBtn) { atcBtn.classList.remove('is-loading'); atcBtn.classList.add('is-success'); }
        if (atcLabel) atcLabel.textContent = '✓ Added!';

        /* Fetch cart to update badge */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Update header badge */
        var badge = document.getElementById('aur-cart-badge');
        if (badge) {
          var n = cart.item_count;
          badge.textContent = n > 99 ? '99+' : String(n);
          badge.classList.toggle('aur-hdr__cart-badge--hidden', n === 0);
          try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() })); } catch (_) {}
        }
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { itemCount: cart.item_count, didError: false } }
        }));

        /* Reset button after delay */
        setTimeout(function () {
          if (atcBtn) { atcBtn.classList.remove('is-success'); }
          if (atcLabel) atcLabel.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function (err) {
        if (atcBtn) atcBtn.classList.remove('is-loading');
        /* Show the real reason (e.g. "Only 2 in stock") when Shopify provides one */
        var label = (err && err.message && err.message.length < 60) ? err.message : 'Try again';
        if (atcLabel) atcLabel.textContent = label;
        setTimeout(function () {
          if (atcLabel) atcLabel.textContent = 'Add to Cart';
        }, 2600);
      });
    });
  }

  /* ── Sticky ATC button ── */
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function () {
      if (productForm) productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* ── Buy now: ADD to the cart then go to checkout ──
     The /cart/{id}:{qty} permalink REPLACES the whole cart, wiping any items
     the customer already has. Intercept the click and add instead; the
     permalink href remains only as a no-JS fallback. */
  if (buyNow) {
    buyNow.addEventListener('click', function (e) {
      if (!IS_LOGGED_IN) return; /* logged-out href points at sign-in — let it navigate */
      if (!currentVariant || !currentVariant.available) { e.preventDefault(); return; }
      e.preventDefault();
      buyNow.style.pointerEvents = 'none';
      buyNow.style.opacity = '0.7';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: currentVariant.id, quantity: currentQty })
      })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok || (res.body && res.body.status)) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        buyNow.style.pointerEvents = '';
        buyNow.style.opacity = '';
        buyNow.textContent = 'Try again';
        setTimeout(function () { updateBuyNow(currentVariant, currentQty); }, 2200);
      });
    });
  }

  /* ── Gallery: switch image ── */
  function switchImage(src, srcset, altText) {
    if (!mainImg || !mainFrame) return;
    mainFrame.classList.add('is-fading');
    setTimeout(function () {
      mainImg.src = src;
      /* Clear a stale srcset when none is supplied, or the browser keeps
         picking from the OLD srcset and the swap silently does nothing. */
      if (srcset) mainImg.srcset = srcset;
      else mainImg.removeAttribute('srcset');
      if (altText) mainImg.alt = altText;
      mainFrame.classList.remove('is-fading');
    }, 280);
  }

  function activateThumb(idx) {
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.imgIndex === String(idx)); });
    dots.forEach(function (d)   { d.classList.toggle('is-active', d.dataset.dot === String(idx)); });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx    = parseInt(this.dataset.imgIndex, 10);
      var src    = this.dataset.imgSrc;
      var srcset = this.dataset.imgSrcset;
      var alt    = this.dataset.imgAlt;
      switchImage(src, srcset, alt);
      activateThumb(idx);
    });
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var idx = parseInt(this.dataset.dot, 10);
      var t = thumbs[idx];
      if (t) t.click();
    });
  });

  /* ── Sticky bar on scroll ── */
  if (stickyBar && atcBtn) {
    var observer = new IntersectionObserver(function (entries) {
      var isVisible = entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', !isVisible);
      stickyBar.removeAttribute('aria-hidden');
      if (isVisible) stickyBar.setAttribute('aria-hidden', 'true');
    }, { threshold: 0.1 });
    observer.observe(atcBtn);
  }

  /* ── Smooth accordion animation ── */
  document.querySelectorAll('.aur-pdp__acc').forEach(function (acc) {
    var summary = acc.querySelector('.aur-pdp__acc-head');
    var body    = acc.querySelector('.aur-pdp__acc-body');
    if (!summary || !body) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = acc.hasAttribute('open');
      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px';
        requestAnimationFrame(function () {
          body.style.transition = 'max-height 0.3s ease, opacity 0.25s ease';
          body.style.maxHeight  = '0';
          body.style.opacity    = '0';
          body.style.overflow   = 'hidden';
          setTimeout(function () {
            acc.removeAttribute('open');
            body.style.maxHeight = '';
            body.style.opacity   = '';
            body.style.transition= '';
            body.style.overflow  = '';
          }, 310);
        });
      } else {
        acc.setAttribute('open', '');
        var h = body.scrollHeight;
        body.style.maxHeight  = '0';
        body.style.opacity    = '0';
        body.style.overflow   = 'hidden';
        requestAnimationFrame(function () {
          body.style.transition = 'max-height 0.35s ease, opacity 0.28s ease';
          body.style.maxHeight  = h + 'px';
          body.style.opacity    = '1';
          setTimeout(function () {
            body.style.maxHeight = '';
            body.style.overflow  = '';
          }, 360);
        });
      }
    });
  });

  /* ── Mobile swipe on main image ── */
  var touchStartX = 0;
  var didSwipe = false;
  var mainImgFrame = document.getElementById('aur-main-frame');
  if (mainImgFrame && thumbs.length > 1) {
    mainImgFrame.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      didSwipe = false;
    }, { passive: true });
    mainImgFrame.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      didSwipe = true; /* suppress the click that follows a swipe */
      var active = Array.from(thumbs).findIndex(function (t) { return t.classList.contains('is-active'); });
      var next = diff > 0
        ? Math.min(active + 1, thumbs.length - 1)
        : Math.max(active - 1, 0);
      if (next !== active && thumbs[next]) thumbs[next].click();
    }, { passive: true });
  }

  /* ── Lightbox zoom ── */
  var lb      = document.getElementById('aur-lb');
  var lbImg   = document.getElementById('aur-lb-img');
  var lbClose = document.getElementById('aur-lb-close');

  if (lb && mainImg) {
    var mainFrameEl = document.getElementById('aur-main-frame');
    if (mainFrameEl) {
      mainFrameEl.style.cursor = 'zoom-in';
      mainFrameEl.addEventListener('click', function () {
        /* Ignore only the click that immediately follows a mobile swipe;
           a normal desktop click / mobile tap always opens the lightbox. */
        if (didSwipe) { didSwipe = false; return; }
        lbImg.src = mainImg.src;
        lbImg.alt = mainImg.alt;
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeLb() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (lbClose) lbClose.addEventListener('click', function (e) { e.stopPropagation(); closeLb(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb();
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-shop-dropdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var DROP = document.getElementById('aur-sdrop');
  if (!DROP) return;

  /* Normalise trigger text: lowercase, collapse whitespace */
  var RAW    = norm(DROP.dataset.trigger || 'shop all');
  var PARTS  = RAW.split(/\s+/).filter(Boolean);   /* ["shop","all"] */
  var panel  = DROP.querySelector('.aur-sdrop__panel');
  var closeTimer    = null;
  var triggerEl     = null;   /* <a> or <button> in the nav */
  var triggerParent = null;   /* parent <li> */
  var inEditor = document.documentElement.classList.contains('shopify-design-mode');
  var domObs   = null;

  /* Move to <body> to escape header's stacking context */
  if (!inEditor && DROP.parentElement !== document.body) {
    document.body.appendChild(DROP);
  }

  function norm(s) {
    return (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  /* Visible label: reads TEXT_NODEs + inline elements, skips SVG/IMG */
  function labelOf(el) {
    var INLINE = /^(SPAN|EM|STRONG|B|I|ABBR|LABEL|S|U)$/;
    var t = '';
    el.childNodes.forEach(function (n) {
      if (n.nodeType === 3) t += n.nodeValue;
      else if (n.nodeType === 1 && INLINE.test(n.tagName)) t += n.textContent;
    });
    return norm(t);
  }

  /* Score each candidate — higher = better match */
  function score(el) {
    var vt   = labelOf(el);
    var full = norm(el.textContent);
    var href = norm(el.getAttribute('href') || '');

    if (vt === RAW)                                              return 100;
    if (vt.includes(RAW))                                       return  90;
    if (full === RAW)                                            return  80;
    /* handles "ShopAll" (no space): check all words present in collapsed string */
    if (PARTS.every(function (p) { return vt.replace(/\s/g,'').includes(p); })) return  70;
    /* href to /collections/all + text contains "shop" */
    if (href.includes('collections/all') && full.includes('shop')) return  65;
    if (full.startsWith(RAW + ' ') || full === RAW)              return  60;
    return 0;
  }

  /* Find the best-scoring nav link or button */
  function findTrigger() {
    var sel = [
      '#header-group a',  '#header-group button',
      '#header-group [role="button"]',
      'header a',         'header button',
      'nav a',            'nav button',
      '[role="navigation"] a', '[role="navigation"] button'
    ].join(',');

    var best = null, bestScore = 0;
    document.querySelectorAll(sel).forEach(function (el) {
      var s = score(el);
      if (s > bestScore) { bestScore = s; best = el; }
    });
    return (bestScore >= 60) ? best : null;
  }

  /* Returns true only for elements that look like native submenu panels */
  function isNativeSubmenu(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    var cls = (el.className || '').toString().toLowerCase();
    return (
      tag === 'UL' ||
      cls.includes('dropdown') ||
      cls.includes('submenu') ||
      cls.includes('mega') ||
      cls.includes('nav-child') ||
      el.hasAttribute('data-submenu')
    );
  }

  /* Kill a native submenu element — NEVER touches the trigger <a> or its <li> */
  function killEl(el) {
    if (!el) return;
    /* Never kill the trigger link, its parent <li>, or any interactive element */
    if (el === triggerEl || el === triggerParent) return;
    if (/^(A|BUTTON|INPUT|LABEL|LI|NAV)$/.test(el.tagName)) return;
    el.style.setProperty('display',         'none',    'important');
    el.style.setProperty('visibility',      'hidden',  'important');
    el.style.setProperty('opacity',         '0',       'important');
    el.style.setProperty('pointer-events',  'none',    'important');
  }

  function suppressNativeMenu() {
    if (!triggerParent) return;
    triggerParent.classList.add('aur-sdrop-trigger');

    /* 1 — kill existing submenu descendants right now */
    try {
      triggerParent.querySelectorAll(
        'ul, [class*="dropdown"], [class*="submenu"], [class*="mega"], [class*="nav-child"], [data-submenu]'
      ).forEach(killEl);
    } catch (e) {}

    /* 2 — handle <details>/<summary> nav pattern */
    var det = triggerParent.querySelector('details');
    if (det) det.removeAttribute('open');

    /* 3 — watch for theme JS injecting/showing native panel.
       Only react to elements that are actual submenus — NOT the <li> itself
       or any class changes on the trigger (e.g. dd-open, is-active).       */
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        /* Attribute change: only kill if the changed element IS a submenu panel */
        if (m.type === 'attributes' && isNativeSubmenu(m.target)) {
          killEl(m.target);
        }
        /* New node added: only kill if it looks like a submenu */
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1 && isNativeSubmenu(n)) {
              killEl(n);
              try { n.querySelectorAll('*').forEach(killEl); } catch (e) {}
            }
          });
        }
      });
    }).observe(triggerParent, {
      childList:       true,
      subtree:         true,
      attributes:      true,
      attributeFilter: ['style', 'class', 'open', 'aria-hidden', 'aria-expanded', 'hidden']
    });

    /* 4 — if the theme moves the panel OUTSIDE <li> via aria-controls */
    var ctrl = triggerEl && triggerEl.getAttribute('aria-controls');
    if (ctrl) {
      var extPanel = document.getElementById(ctrl);
      if (extPanel) killEl(extPanel);
    }
  }

  /* Position the panel below the trigger link */
  function reposition() {
    if (!triggerEl) return;
    var rect = triggerEl.getBoundingClientRect();
    /* If element has no size (hidden / wrong match), use parent */
    if (rect.width === 0) rect = (triggerParent || triggerEl).getBoundingClientRect();
    var pw   = (panel && panel.offsetWidth) || 348;
    var left = rect.left + rect.width / 2 - pw / 2;
    left = Math.max(16, Math.min(left, window.innerWidth - pw - 16));
    DROP.style.setProperty('--sdrop-x', left + 'px');
    DROP.style.setProperty('--sdrop-y', (rect.bottom + 8) + 'px');
  }

  function openDrop() {
    clearTimeout(closeTimer);
    reposition();
    DROP.classList.add('is-open');
    DROP.setAttribute('aria-hidden', 'false');
    DROP.querySelectorAll('a[tabindex="-1"]').forEach(function (a) { a.removeAttribute('tabindex'); });
    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
  }

  function closeDrop(delay) {
    closeTimer = setTimeout(function () {
      DROP.classList.remove('is-open');
      DROP.setAttribute('aria-hidden', 'true');
      DROP.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
    }, delay == null ? 140 : delay);
  }

  function bindEvents() {
    triggerParent.addEventListener('mouseenter', openDrop);
    triggerParent.addEventListener('mouseleave', function () { closeDrop(); });
    DROP.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    DROP.addEventListener('mouseleave', function () { closeDrop(); });

    triggerEl.addEventListener('click', function (e) {
      if (window.innerWidth < 750 || window.matchMedia('(hover: none)').matches) return;
      if (DROP.classList.contains('is-open')) { closeDrop(0); }
      else { e.preventDefault(); openDrop(); }
    });

    document.addEventListener('click', function (e) {
      if (!DROP.contains(e.target) && !triggerParent.contains(e.target)) closeDrop(0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrop(0); if (triggerEl) triggerEl.focus(); }
    });

    window.addEventListener('resize', function () {
      if (DROP.classList.contains('is-open')) reposition();
    });
  }

  /* Bootstrap — try immediately, then watch DOM for nav to render */
  function tryInit() {
    triggerEl = findTrigger();
    if (!triggerEl) return false;

    /* Stop DOM observer — we found our target */
    if (domObs) { domObs.disconnect(); domObs = null; }

    triggerParent = triggerEl.closest('li') || triggerEl.parentElement;
    triggerEl.setAttribute('aria-haspopup', 'true');
    triggerEl.setAttribute('aria-expanded', 'false');
    suppressNativeMenu();
    bindEvents();
    return true;
  }

  function init() {
    if (tryInit()) return;

    /* Nav not in DOM yet — observe until it appears */
    domObs = new MutationObserver(function () {
      if (tryInit()) domObs.disconnect();
    });
    domObs.observe(document.body, { childList: true, subtree: true });

    /* Safety timeout: stop observing after 8 seconds */
    setTimeout(function () {
      if (domObs) { domObs.disconnect(); domObs = null; }
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurova-trust-badges"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aurova-trust').forEach(function(sec) {
  var items = sec.querySelectorAll('[data-animate]');
  if (!items.length) return;

  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var el  = entry.target;
      var idx = parseInt(el.dataset.index || 0, 10);
      el.style.animationDelay = (idx * 95) + 'ms';
      el.classList.add('is-visible');
      obs.unobserve(el);
    });
  }, { threshold: 0.15 });

  items.forEach(function(el) { obs.observe(el); });
  setTimeout(function() {
    items.forEach(function(el) { el.classList.add('is-visible'); });
  }, 1200);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
